import { AController } from "@eagerlogic/react-mvc";
import { GeneralSettingsModel, VacationTypeModel } from "../model/GeneralSettingsModel";
import { ListWorkDaysResp, WorkDaysRpc } from "rpc/settings/WorkDaysRpc";
import { MetaVacationTypeDto } from "rpc/meta";
import { Meta } from "utils/meta";
import { VacationTypesRpc } from "rpc/settings/VacationTypesRpc";
import { EditVacationTypeDialogModel } from "../model/EditVacationTypeDialogModel";
import { ExtraWorkDaysModel, ExtraWorkDayHoliday } from "../model/ExtraWorkDaysModel";
import { ExtraWorkDaysRpc, ListResp } from "rpc/settings/ExtraWorkDaysRpc";

export class GeneralSettingsController extends AController<GeneralSettingsModel> {

    protected createInitialModel(): GeneralSettingsModel {
        return this.reload();
    }

    public onDeleteVacationType(id: string) {
        this.model.deletingVacationId = id;
        this.render(this.model);
    }

    public onSureDeleteVacationType() {
        var nvts: VacationTypeModel[] = [];
        var dtos: MetaVacationTypeDto[] = [];
        for (var vtm of this.model.vacationTypes) {
            if (vtm.id == this.model.deletingVacationId) {
                continue;
            }
            nvts.push(vtm);
            dtos.push({
                id: vtm.id,
                name: vtm.name,
                color: vtm.color
            });
        }

        this.model.vacationTypes = nvts;
        this.model.deletingVacationId = null;
        this.render(this.model);

        VacationTypesRpc.save(dtos).then(() => { Meta.load() });
    }

    public onCancelDeleteVacationType() {
        this.model.deletingVacationId = null;
        this.render(this.model);
    }

    public onAddVacationTypeClicked() {
        var dm = new EditVacationTypeDialogModel();
        dm.id = null;
        dm.name = "";
        dm.color = "#81c784";
        this.model.editVacationTypeDialogModel = dm;
        this.render(this.model);
    }

    public onEditVacationTypeClicked(id: string) {
        for (var vt of this.model.vacationTypes) {
            if (vt.id == id) {
                var dm = new EditVacationTypeDialogModel();
                dm.id = id;
                dm.name = vt.name;
                dm.color = vt.color;
                this.model.editVacationTypeDialogModel = dm;
                this.render(this.model);
                return;
            }
        }
    }

    public onCancelEditVacationTypeClicked() {
        this.model.editVacationTypeDialogModel = null;
        this.render(this.model);
    }

    public onSaveVacationTypeClicked(id: string, name: string, color: string) {
        var newId = id;
        if (newId == null) {
            newId = name;
        }

        if (name == null || name.trim().length < 1) {
            this.model.editVacationTypeDialogModel.error = "The name is mandatory!";
            this.render(this.model);
            return;
        }
        name = name.trim();

        if (color == null || color.length < 1) {
            this.model.editVacationTypeDialogModel.error = "The color is mandatory!";
            this.render(this.model);
            return;
        }

        if (id == null) {
            var fine: boolean = false;
            var idx = 2;
            while (!fine) {
                fine = true;
                for (var vt of this.model.vacationTypes) {
                    if (vt.id == newId) {
                        fine = false;
                        newId = name + " " + idx;
                        idx++;
                        break;
                    }
                }
            }

            this.model.vacationTypes.push(new VacationTypeModel(newId, name, color));
        } else {
            for (var vt of this.model.vacationTypes) {
                if (vt.id == newId) {
                    vt.name = name;
                    vt.color = color;
                    break;
                }
            }
        }

        this.model.editVacationTypeDialogModel = null;
        this.render(this.model);

        var dtos: MetaVacationTypeDto[] = [];
        for (var vtm of this.model.vacationTypes) {
            dtos.push({
                id: vtm.id,
                name: vtm.name,
                color: vtm.color
            });
        }

        VacationTypesRpc.save(dtos).then(() => {Meta.load()});
    }

    public onEditworkdaysClicked() {
        this.model.isEditWorkdaysDialogVisible = true;
        this.render(this.model);
    }

    public onCancelEditWorkdaysClicked() {
        this.model.isEditWorkdaysDialogVisible = false;
        this.render(this.model);
    }

    public onSaveWorkdaysClicked(workdays: boolean[]) {
        this.model.workDays = workdays;
        this.model.isEditWorkdaysDialogVisible = false;
        this.render(this.model);

        WorkDaysRpc.save({workDays: workdays});
    }

    public async onAddExtraWorkDay(date: string, description: string, isHoliday: boolean): Promise<void> {
        return ExtraWorkDaysRpc.add({date: date, desc: description, holiday: isHoliday})
        .then((res) => {
            this.render(this.reload())
        });

    }

    public async onDeleteExtraWorkDay(id: number) {
        ExtraWorkDaysRpc.delete(id);

        for (var i = 0; i < this.model.extraWorkDays.extraWorkDays.length; i++) {
            var ewdm = this.model.extraWorkDays.extraWorkDays[i];
            if (ewdm.id == id) {
                this.model.extraWorkDays.extraWorkDays.splice(i, 1);
                break;
            }
        }

        this.render(this.model);
    }

    private reload(): GeneralSettingsModel {
        var res = new GeneralSettingsModel(true, [true, true, true, true, true, false, false], [], new ExtraWorkDaysModel());
        res.isInit = true;

        var wdP = WorkDaysRpc.list();
        var ewdP = ExtraWorkDaysRpc.list();

        Promise.all([wdP, ewdP])
        .then((res) => {
            var wd = res[0];
            var ewd = res[1];
            this.refreshModel(wd, Meta.get().vacationTypes, ewd);
        });

        return res;
    }

    private refreshModel(listWorkDaysResp: ListWorkDaysResp, vacationTypes: MetaVacationTypeDto[], extraWorkDaysResp: ListResp) {
        this.model.isInit = false;
        this.model.workDays = listWorkDaysResp.workDays;
        this.model.vacationTypes = vacationTypes;

        this.model.extraWorkDays = new ExtraWorkDaysModel();
        for (var ewd of extraWorkDaysResp.items) {
            var ewdm = new ExtraWorkDayHoliday();
            ewdm.id = ewd.id;
            ewdm.date = ewd.date;
            ewdm.desc = ewd.desc;
            ewdm.isHoliday = ewd.holiday;
            this.model.extraWorkDays.extraWorkDays.push(ewdm);
        }

        this.render(this.model);
    }

}